import api from '@/shared/api';
import type { ApiResponse } from '@/shared/lib';

export interface AttributionData {
  memberIds: number[];
  positionIds: number[];
}

export interface AttributionsResponse {
  training: AttributionData;
  verification: AttributionData;
}

class AttributionApi {
  async getAttributions(): Promise<AttributionsResponse> {
    const response = await api.get<ApiResponse<AttributionsResponse>>('/admin/attributions');
    if (!response.data.data) {
      throw new Error('Resposta inválida ao carregar atribuições');
    }
    return response.data.data;
  }

  async updateAttributions(payload: AttributionsResponse): Promise<AttributionsResponse> {
    const response = await api.put<ApiResponse<AttributionsResponse>>('/admin/attributions', {
      training: payload.training,
      verification: payload.verification,
    });
    if (!response.data.data) {
      throw new Error('Resposta inválida ao salvar atribuições');
    }
    return response.data.data;
  }
}

export const attributionApi = new AttributionApi();
